class GiftWrapCheckbox extends HTMLElement {
    constructor() {
        super();
        this.cartForm = this.querySelector('cart-form');
        this.giftWrapProductId = this.getAttribute('data-variant-id');
        this.checkbox = this.querySelector('#gift-wrap-checkbox');
    }

    connectedCallback() {
        this.initializeState();
        this.addEventListeners();
    }

    initializeState() {
        try {
            const isChecked = this.getStoredGiftWrapState();
            this.checkbox.checked = isChecked;
        } catch (error) {
            console.error('Error initializing gift wrap state:', error);
        }
    }

    addEventListeners() {
        this.checkbox.addEventListener('change', (event) => {
            const isChecked = event.target.checked;

            try {
                this.setStoredGiftWrapState(isChecked);
                if (isChecked) {
                    this.addProductToCart(this.giftWrapProductId);
                } else {
                    this.removeProductFromCart(this.giftWrapProductId);
                }
            } catch (error) {
                console.error('Error updating gift wrap state:', error);
            }
        });
    }

    getStoredGiftWrapState() {
        return localStorage.getItem(`giftWrap-${this.giftWrapProductId}`) === 'true';
    }

    setStoredGiftWrapState(isChecked) {
        localStorage.setItem(`giftWrap-${this.giftWrapProductId}`, isChecked);
    }

    async addProductToCart(variantId) {
        try {
            await this.cartForm?.formDataAPI?.updateItems({
                id: variantId,
                quantity: 1,
            });
            this.cartForm?.reqCart();
            this.setStoredGiftWrapState(true);
        } catch (error) {
            console.error('Error adding product to cart:', error);
        }
    }

    async removeProductFromCart(variantId) {
        try {
            await this.cartForm?.formDataAPI?.updateItems({
                id: variantId,
                quantity: 0,
            });
            this.cartForm?.reqCart();
            this.setStoredGiftWrapState(false);
        } catch (error) {
            console.error('Error removing product from cart:', error);
        }
    }
}

customElements.define('gift-wrap-checkbox', GiftWrapCheckbox);